import DocumentsIndexPage from '../../components/pages/documents/Index'


const routes = [
  {
    path: '/',
    name: 'index',
    component: DocumentsIndexPage
  },
  /*{
    path: '/me',
    name: 'me',
    component: Users
  },*/
]

export default routes
